import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id, companyId, storeId } = payload || {}
    const finalId = companyId || id || storeId;
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RESTAURANT_DETAIL, {
      pathParams: {
        restaurantId: finalId,
      },
    })
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 404,
        message: raw?.message || 'Restaurant non trouvé',
        data: null,
      }
    }

    const restaurant = raw.data || {}
    
    // extract owner details
    let ownerName = null
    const globalData = typeof window !== 'undefined' ? window.__RAPIDOO_GLOBAL_DATA__ : null
    if (globalData?.restaurantUsers) {
      const owner = globalData.restaurantUsers.find(u => u.id === restaurant.userId || u.userId === restaurant.userId || u.id === restaurant.ownerId)
      if (owner) {
        ownerName = `${owner.firstName || ''} ${owner.lastName || ''}`.trim() || owner.email || 'Sans nom'
      }
    }

    // map stats
    const stats = restaurant.statistics || restaurant.stats || {}
    const totalOrders = stats.ordersCount || stats.totalOrders || 0
    const totalDelivered = stats.ordersCount || stats.totalOrdersDelivered || 0
    const totalRevenue = stats.totalRevenue || 0
    const totalDishes = restaurant.totalDishes || 0

    return {
      statusCode: 200,
      message: 'ok',
      data: {
        id: restaurant.id,
        userId: restaurant.userId || restaurant.ownerId,
        owner: ownerName,
        facebookLink: restaurant.socialLinks?.facebook || restaurant.facebookLink || '',
        instagramLink: restaurant.socialLinks?.instagram || restaurant.instagramLink || '',
        linkedinLink: restaurant.socialLinks?.linkedin || restaurant.linkedinLink || '',
        twitterLink: restaurant.socialLinks?.twitter || restaurant.twitterLink || '',
        logo: restaurant.logo || '',
        cover: restaurant.cover || restaurant.images?.[0] || '',
        name: restaurant.storeName || restaurant.name || '',
        accompaniementPrice: restaurant.accompanimentPrice || restaurant.accompaniementPrice || {},
        country: restaurant.country || '',
        city: restaurant.city || '',
        address: restaurant.address?.address || restaurant.address?.street || restaurant.address?.city || restaurant.address || '',
        isVisible: restaurant.isVisible ?? false,
        isActive: restaurant.status === 'approved' || restaurant.active === true,
        status: restaurant.status || (restaurant.active ? 'active' : 'inactive'),
        isOpen: restaurant.isOpen ?? false,
        balance: restaurant.balance || 0,
        drinks: restaurant.drinks || [],
        // Stats
        totalOrders,
        totalDelivered,
        totalRevenue,
        totalDishes,
        openingHours: restaurant.openingHours || {}
      },
    }
  },
}
